import React from 'react'
import '../styles/Career.css'

import carrerimg2 from '../assest/image.png'


const Career = () => {
  return (
    <>
     


      <div className='career-section' id='Careers'>
        <div className='career-container'>
          <div className='career-left'>
            <h1 className='careerh1'> Join <span>CauZen</span></h1>

            <p>At  Cauzen we are more than just a tech team, we are problem solvers, creators,  and collaborators. We work on exciting projects that make a real impact and  we’re passionate  about innovation, learning, and growth.
            </p>

          </div>
          <div className='career-right'>
            <div className='career-image-box'>
              <img src={carrerimg2} />
            </div>
          </div>
        </div>
      </div>

      <div className='career-wrapper2'>
        <div className='career-box-container'>
          <h2>Elevating Success with Collaboration and Learning</h2>
          <div className='career-box-container2'>
            <div className='career-box1'>
              <i className="fa-solid fa-chart-simple"></i>
              <h2>Learning and development</h2>
              <p>Access to training programs and educational resources.</p>
            </div>
            <div className='career-box2'>
              <i className="fa-solid fa-briefcase"></i>
              <h2>Work-life balance</h2>
              <p>Flexible work arrangements to promote a healthy work-life balance.</p>
            </div>
            <div className='career-box3'>
              <i className="fa-solid fa-diagram-project"></i>
              <h2>Challenging projects</h2>
              <p>Engaging in diverse and challenging projects.</p>
            </div>
          </div>
        </div>
      </div>
      <div className='current-wrapper'>
    <div className='current-container'>

            <h1>Current <span>Opening</span></h1>
            <ul>
              <li>Frontend Developer</li>
              <li>Backend Developer</li>
              <li>UI/UX Designer</li>
              <li>DevOps </li>
            </ul>
          <h2>Please drop an email at <a href="https://mail.google.com/mail/?view=cm&fs=1&to=careers@cauzen.com">careers@cauzen.com</a> with your resume. Our recruitment team will get in touch with you.</h2>
      
          </div>
</div>

      {/* <div className='career-wrapper2'>
          <div className='career-box-container'>
            <div className='career-box1'>
              <i className="fa-solid fa-chart-simple"></i>
              <h2>Learning and development</h2>
              <p>Access to training programs and educational resources.</p>
            </div>
            <div className='career-box2'>
              <i className="fa-solid fa-briefcase"></i>
              <h2>Work-life balance</h2>
              <p>Flexible work arrangements to promote a healthy work-life balance.</p>
            </div>
            <div className='career-box3'>
              <i className="fa-solid fa-diagram-project"></i>
              <h2>Challenging projects</h2>
              <p>Engaging in diverse and challenging projects.</p>
            </div>
               </div> */}

      {/* </div>
          <div className='current-container'>
            <h1>Current <span>Opening</span></h1>
            <ul>
              <li>Frontend developer</li>
              <li>Backend developer</li>
              <li>Ui Ux designer</li>
              <li>Devops </li>
            </ul>
          </div>
          <h2>Please drop an email at <a href="https://mail.google.com/mail/?view=cm&fs=1&to=careers@cauzen.com">careers@cauzen.com</a> with your resume. Our recruitment team will get in touch with you.</h2>
        </div> */}



    </>
  )
}

export default Career;
